/* PDP only (loaded by sections/main-product.liquid): the "More payment options" link shown when Shopify offers no such link of its own
   (e.g. only "Buy it now") starts Shopify's own "Buy it now" button, which leads to the checkout with all payment options. */
document.addEventListener('click', function (event) {
  var link = event.target.closest('.pdp-more-payment');
  if (!link) return;

  event.preventDefault();
  var scope = link.closest('.product-form__buttons') || document;
  var button =
    scope.querySelector('.shopify-payment-button .shopify-payment-button__button--unbranded') ||
    scope.querySelector('.shopify-payment-button [slot="button"]');
  if (button) button.click();
});
